import { useEffect, useRef, useState } from "react";

// Glowing dot + trailing particles. Color follows the current world.
// Disabled on touch / coarse-pointer devices.
const TRAIL = 8;

export default function CustomCursor({ color = "#FF2A6D" }) {
  const dotRef = useRef(null);
  const trailRefs = useRef([]);
  const [enabled] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(pointer: fine)").matches
  );

  useEffect(() => {
    if (!enabled) return;
    const pts = Array.from({ length: TRAIL }).map(() => ({ x: -100, y: -100 }));
    let mx = -100;
    let my = -100;
    let raf;
    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
    };
    window.addEventListener("mousemove", onMove);
    const loop = () => {
      if (dotRef.current) dotRef.current.style.transform = `translate(${mx}px, ${my}px)`;
      let x = mx;
      let y = my;
      pts.forEach((p, i) => {
        p.x += (x - p.x) * 0.35;
        p.y += (y - p.y) * 0.35;
        x = p.x;
        y = p.y;
        const el = trailRefs.current[i];
        if (el) el.style.transform = `translate(${p.x}px, ${p.y}px)`;
      });
      raf = requestAnimationFrame(loop);
    };
    loop();
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div className="wv-cursor-layer" aria-hidden="true">
      {Array.from({ length: TRAIL }).map((_, i) => (
        <span
          key={i}
          ref={(el) => (trailRefs.current[i] = el)}
          className="wv-cursor-trail"
          style={{
            background: color,
            width: `${10 - i}px`,
            height: `${10 - i}px`,
            opacity: (TRAIL - i) / 18,
          }}
        />
      ))}
      <span
        ref={dotRef}
        className="wv-cursor-dot"
        style={{ background: color, boxShadow: `0 0 10px ${color}, 0 0 22px ${color}` }}
      />
    </div>
  );
}
